@if (showPrices()) {
  @switch (accessoryType()) {
    @case (accessoryTypeEnum.STD) {
      <ng-container *ngTemplateOutlet="type"></ng-container>
    }
    @case (accessoryTypeEnum.CFG) {
      <ng-container *ngTemplateOutlet="type"></ng-container>
    }
    @case (accessoryTypeEnum.UR) {
      <ng-container *ngTemplateOutlet="type"></ng-container>
    }
    @case (accessoryTypeEnum.RFQ) {
      <ng-container *ngTemplateOutlet="manageRfq"></ng-container>
    }
    @case (accessoryTypeEnum.DASH) {
      <ng-container *ngTemplateOutlet="price_tpl"></ng-container>
    }
    @default {
      <ng-container *ngTemplateOutlet="price_tpl"></ng-container>
    }
  }
} @else {
  <span>-</span>
}

<ng-template #type>
  {{ accessoryPrice() !== null && accessoryType() ? accessoryType() : ('' | lowercase) }}
</ng-template>

<ng-template #price_tpl>
  <apm-price
    [prices]="prices()"
    [priceType]="selectedPrice()"
    [applyCurrencyConversion]="applyCurrencyConversion()"
    [currencySymbol]="priceCurrencySymbol()"
  ></apm-price>
</ng-template>

<ng-template #manageRfq>
  @if (canMenageRfq && editable()) {
    <apm-currency-input
      #priceInput
      [(ngModel)]="rfqPrice"
      [currencyMask]="currencyMaskOptions()"
      additionalClass="w-100 text-end text"
    ></apm-currency-input>
  } @else {
    @if (!accessoryPrice()) {
      <ng-container *ngTemplateOutlet="type"></ng-container>
    } @else {
      <apm-price
        [prices]="prices()"
        [priceType]="selectedPrice()"
        [applyCurrencyConversion]="applyCurrencyConversion()"
        [currencySymbol]="priceCurrencySymbol()"
      ></apm-price>
    }
  }
</ng-template>
